import { render, staticRenderFns } from "./PlanSelection.vue?vue&type=template&id=12696d3e"
import script from "./PlanSelection.vue?vue&type=script&lang=ts"
export * from "./PlanSelection.vue?vue&type=script&lang=ts"
import style0 from "./PlanSelection.vue?vue&type=style&index=0&id=12696d3e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports